// extracted by mini-css-extract-plugin
module.exports = {"root":"cta-block_root__p0mrK","mobile":"cta-block_mobile__EryDU","heading":"cta-block_heading__ioHJX"};